<template>
  <div class="bg">
    <div class="gameStart">
      <img class="banner" src="../../assets/img/flex-bg-cover.svg" width="100%" alt="">
      <router-link class="btn btn-warning btn-lg rounded-0 start-btn" to="/way">
        馬上挑戰
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Start',
  data() {
    return {
      data: [],
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.bg{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00251a;
}
.gameStart{
  flex-direction: column;
  display: flex;
  width: 100%;
  min-width: 1024px;
  max-width: 1600px;
  // height: 800px;
  background-color: #00251a;
  // background-image: url('../../assets/img/flex-bg-cover.svg');
  background-repeat: no-repeat;
  background-size: 1024px;
  background-position: center;
  position: fixed;
  justify-content: flex-end;
  // padding-bottom: 50px;
  align-items: center;
  .banner{
    max-height: 95vh;
  }
  .start-btn{
    position: absolute;
    bottom: 7%;
    font-weight: bold;
  }
  form {
    display: flex;
    align-items: center;
    input {
      height: 65px;
      padding: 20px;
      font-weight: bold;
      font-size: 24px;
      color: #00251A;
    }
    input[type=text] {
      width: 365px;
      border: 2px #00251A solid;
    }
    input[type=submit] {
      width: 175px;
      background-color: #00251A;
      color: #fff;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      &:hover {
        background-color: #004D40;
      }
    }
    /*webkit瀏覽器專用*/
    ::-webkit-input-placeholder {
      color: #00251A;
      font-weight: bold;
    }
    /*Firefox 4-18瀏覽器專用*/
    input::-moz-placeholder {
      color: #00251A;
      font-weight: bold;
    }
    /*Firefox 19+瀏覽器專用*/
    input::-moz-placeholder{
      color:#00251A;
    }
    /*IE10瀏覽器專用*/
    &:-ms-input-placeholder{
      color: #00251A;
    }
  }
}
</style>
